import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { intlShape } from "react-intl";

import { Timeout } from "./";
import * as intlActions from "../intl/intlActions";
import * as loginActions from "./loginActions";
import HomePage from "../common/HomePage";
import ServiceUnavailable from "./ServiceUnavailable";
import { LOGIN_FAILURE } from "./loginActionTypes";
import { getTenantFromURL } from "../common/MultiTenancy/MultiTenancyHelper";
import keycloakManager from "./sso/keycloakManager";
import { getSessionCookies } from "../common/sessions/tokenHelper";
import userHasAccess from "../../utils/userHasAccess";
import { EXTERNAL_ROLES } from "../../utils/Roles";

/**
 * Get API Status
 *
 *  Status is considered BAD (False) if /v1/health returns anything
 *  but a successful response with status 200 OK
 *
 * @returns {Promise<boolean>}
 */
const getAPIStatus = async () => {
  try {
    const tenantHeader = getTenantFromURL();
    const response = await fetch(`${__API_URL__}/v1/health`, {headers: {"tenant": tenantHeader}});
    return response.ok;
  } catch (_) {
    return false;
  }
};

class Login extends React.Component {
  constructor(props, context) {
    super(props, context);

    const {
      location: {
        query: { timeout },
      },
    } = props;
    this.state = {
      timeout,
      serviceAvailable: true,
      isLoading: true,
    };

    this.ssoLogin = this.ssoLogin.bind(this);
  }

  async componentWillMount() {
    const isUp = await getAPIStatus();
    this.setState({
      ...this.state,
      serviceAvailable: isUp,
      isLoading: false,
    });

    if (isUp && !this.state.timeout) {
      const [accessToken, refreshToken] = getSessionCookies();
      if (accessToken) {
        this.props.loginActions.verifyAuth().then((data) => {
          if (data && data.type == LOGIN_FAILURE)
            this.ssoLogin(accessToken, refreshToken);
        });
      } else {
         this.ssoLogin();
      }
    } 
  }

  async componentWillUpdate(nextProps) {
    const { locale } = this.context.intl;
    const userLanguage = localStorage.getItem("languageCode") || "en-CA";
    const associatedClientIds = JSON.parse(sessionStorage.getItem("associatedClientIds") || "[]");
    const firstClientId = associatedClientIds.length > 0 ? associatedClientIds[0] : null;

    if (!!nextProps.auth.user) {
      if (locale !== userLanguage) {
        this.props.intlActions.setLocale(userLanguage);
      }

      if (userHasAccess(EXTERNAL_ROLES, true)) {
        let nextPathname = "/dashboard/no-data";
        if (firstClientId)
          nextPathname = `/dashboard/clients/${firstClientId}/members`;
        this.context.router.push(nextPathname);
      } else {
        const intendedPath = this.props.location.state && this.props.location.state.nextPathname;
        if (intendedPath) {
          this.context.router.push(intendedPath);
        } else {
          this.context.router.push("/dashboard");
        }
      }
    }
  }

  ssoLogin(accessToken=null, refreshToken=null) {
    keycloakManager.login(accessToken, refreshToken, this.props.loginActions);
  }

  onModalClose() {
    this.context.router.push("/login");
    location.reload();
  }


  render() {
    const { serviceAvailable: enableLogin, isLoading } = this.state;

    return (
      <HomePage>
        {!enableLogin && !isLoading && (
          <ServiceUnavailable />
        )}
        <Timeout
          onClose={() => this.onModalClose()}
          show={!!this.state.timeout}
        />
      </HomePage>
    );
  }
}

Login.propTypes = {
  auth: PropTypes.object.isRequired,
  intlActions: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  loginActions: PropTypes.object.isRequired,
};

Login.contextTypes = {
  intl: intlShape,
  router: React.PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    intlActions: bindActionCreators(intlActions, dispatch),
    loginActions: bindActionCreators(loginActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/login/LoginPage.js